import { erpAxios } from '.';

const getMatrica = async () => {
  const { data } = await erpAxios('/kreditna-matrica');
  return data;
};

export default getMatrica;
